import { Form, Input, Typography } from "antd";
import { AiOutlineArrowRight } from "react-icons/ai";

import PrimaryButton from "../Forms/PrimaryButton";
import { useGlobalModal } from "../../context/SuccessModalProvider";

const { Title } = Typography;

const RejectClient = ({ setRejectRemark, rejectRemark, title, handleSubmit, loading }) => {
  const { showPopup } = useGlobalModal();
  return (
    <>
      {/* Header */}
      <div className="flex justify-between items-center">
        <Title level={2} className="text-lg font-semibold text-black m-0 font-abhaya">
          {title}
        </Title>
      </div>

      {/* Form */}
      <Form layout="vertical">
        <Form.Item label="Remark" className="font-semibold mb-3">
          <Input.TextArea
            value={rejectRemark}
            onChange={(e) => setRejectRemark(e.target.value)}
            rows={4}
            placeholder="Add a remark here..."
            className="rounded-lg"
          />
        </Form.Item>

        {/* Footer */}
        <div className="w-full flex justify-center">
          <PrimaryButton
            text={title}
            className="me-[30px]"
            onClick={() => {
              if (!rejectRemark?.trim())
                return showPopup({
                  title: null,
                  content: <span className="custom-modal-title">Please add a remark.</span>,
                  onOk: () => console.log("Confirmed!"),
                  className: "custom-success-modal",
                });
              handleSubmit();
            }}
            loading={loading}
          />
        </div>
      </Form>
    </>
  );
};

export default RejectClient;
